/** Static assets in `public/` */
export const SITE_LOGO_SRC = "/homeraj-logo.webp";
export const BROCHURE_QR_SRC = "/brochure-qr.webp";

/** Dropbox shared brochure — dl=1 serves the file directly for tap-to-open. */
export const BROCHURE_PDF_URL =
  "https://www.dropbox.com/scl/fi/qd0njbgtxxfqdg7t0h7ch/brochure-homeraj.pdf?rlkey=5c3bhntq43jknpta6zx64d8iw&st=36utabc2&dl=1";

export const CONTACT_EMAIL = "realtyhomeraj@gmail.com";

export const LINKEDIN_URL = "https://www.linkedin.com/in/homeraj-realty-07740234a/";
